export { default as newId } from "./newId";
export { default as isDigit } from "./isDigit";
export { default as withRedux } from "./withRedux";
export { default as validateEmail } from "./validateEmail";
export { default as validateUrl } from "./validateUrl";
export { default as priceToDollars } from "./priceToDollars";
export { default as parseQuery } from "./parseQuery";
export { default as getSortedDataToDisplay } from "./getSortedDataToDisplay";
export { default as sortDataByIdAndOrder } from "./sortDataByIdAndOrder";
export { default as getTextColor } from "./TextColorPicker";
export { default as formatDollarsToCents } from "./formatDollarsToCents";
export { default as SecureLocalStorage } from "./SecureLocalStorage";
export { default as ClearStorage } from "./ClearStorage";

export * from "./uploadWidget";
export * from "./loadingActions";
export * from "./errorActions";
export * from "./removeEmptyParams";

export const dig = (target, ...keys) => {
  let digged = target;
  for (const key of keys) {
    if (typeof digged === "undefined" || digged === null) {
      return undefined;
    }
    if (typeof key === "function") {
      digged = key(digged);
    } else {
      digged = digged[key];
    }
  }
  return digged;
};

export const isMobileDevice = () => {
  var isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);
  return isMobile;
  return (
    typeof window.orientation !== "undefined" ||
    navigator.userAgent.indexOf("IEMobile") !== -1
  );
};
